import { useEffect, useState } from 'react';

/**
 * Width of the vertical scrollbar of the page scroll container (`.layout__right`), 0 when there is none
 * or it is an overlay scrollbar. For elements fixed to the right edge of the viewport: the page scrolls
 * inside `.layout__right`, not the window, so `right: 0` lands ON the scrollbar unless offset by this.
 */
const useLayoutScrollbarWidth = (): number => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const container = document.querySelector<HTMLElement>('.layout__right');
    if (!container) return;

    const measure = () => setWidth(container.offsetWidth - container.clientWidth);
    measure();

    // Content growing/shrinking toggles the scrollbar without a window resize.
    const observer = new ResizeObserver(measure);
    observer.observe(container);
    const main = container.querySelector('main');
    if (main) observer.observe(main);
    window.addEventListener('resize', measure);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return width;
};

export default useLayoutScrollbarWidth;
